import { render, staticRenderFns } from "./integral_market.vue?vue&type=template&id=7ba5596c&scoped=true&"
import script from "./integral_market.vue?vue&type=script&lang=js&"
export * from "./integral_market.vue?vue&type=script&lang=js&"
import style0 from "./integral_market.vue?vue&type=style&index=0&id=7ba5596c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba5596c",
  null
  
)

export default component.exports